import { useNavigate } from 'react-router-dom';
import { MyOrder } from '../../interfaces/Order/MyOrder';
import { Pagination } from '../../interfaces/Pagination';
import { TableColumn } from '../DataTable/TableColumn';
import { TextColumn } from '../DataTable/TextColumn';
import { DateColumn } from '../DataTable/DateColumn';
import { PriceColumn } from '../DataTable/PriceColumn';
import { ButtonColumn } from '../DataTable/ButtonColumn';
import { DataTable } from '../DataTable/DataTable';
import { useLocalizedText } from '../../hooks/useLocalizedText';

type OrdersTableProps = {
  orders: MyOrder[];
  totalCount: number;
  pagination?: Pagination;
  onPagination?: (newPagination: Pagination) => void;
  headless?: boolean;
  loading?: boolean;
  readOnly?: boolean;
};

export const OrdersTable = ({
  orders,
  totalCount,
  pagination,
  onPagination,
  headless,
  loading,
  readOnly = false,
}: OrdersTableProps) => {
  const t = useLocalizedText();

  const navigate = useNavigate();

  const columns: TableColumn<MyOrder>[] = [
    {
      id: 'id',
      name: t('order.id'),
      accessor: (row) => <TextColumn value={row.id.toString()} />,
    },
    {
      id: 'created-at',
      name: t('order.date'),
      accessor: (row) => <DateColumn value={row.createdAt} />,
    },
    {
      id: 'total',
      name: t('order.total'),
      accessor: (row) => <PriceColumn value={row.orderTotal.raw} />,
    },
    ...(readOnly
      ? []
      : [
          {
            id: 'details',
            name: '',
            accessor: (row) => (
              <ButtonColumn
                label={t('order.details')}
                onClick={() => navigate(`/hesabim/siparis-detayi/${row.id}`)}
              />
            ),
          } satisfies TableColumn<MyOrder>,
        ]),
  ];

  return (
    <DataTable
      columns={columns}
      totalCount={totalCount}
      rows={orders}
      limit={pagination?.pageSize}
      setLimit={(newLimit) => onPagination?.({ page: 0, pageSize: newLimit })}
      page={pagination?.page}
      setPage={(newPage) =>
        onPagination?.({ pageSize: 5, ...pagination, page: newPage })
      }
      hidePagination={!pagination}
      linkGenerator={
        readOnly ? undefined : (row) => `/hesabim/siparis-detayi/${row.id}`
      }
      headless={headless}
      loading={loading}
    />
  );
};
